import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	constructor(
		private authService: AuthService
	) { }

	public canActivate(): Observable<boolean> {
		return this.authService.isAuthenticated$
			.pipe(
				switchMap(isAuthenticated => {
					if (!isAuthenticated) {
						return this.authService.msalLogin();
					}

					return of(true);
				})
			);
	}
}
